import { Component } from '@angular/core';

@Component({
    selector: 'app-recipes',
    imports: [],
    templateUrl: './recipes.component.html',
    styleUrl: './recipes.component.scss'
})
export class RecipesComponent {

}
